import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NiceSelectModule } from "ng-nice-select";

import { SignupRoutingModule } from '@teem/features/auth/signup/signup-routing.module';
import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';
import { SignupComponent } from '@teem/features/auth/signup/signup.component';
// import { LoadingComponent } from '@teem/layouts/loading/loading.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';


@NgModule({
  declarations: [
    SignupComponent,
    // LoadingComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
		ReactiveFormsModule,
    NgxIntlTelInputModule,
    CoreModule,
    SharedModule,
    NgxPaginationModule,
    NiceSelectModule,
    SignupRoutingModule
  ]
})
export class SignupModule {
  
}
